// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'search-minus';

export const Component = () => (
  <path d='M14.792 10.434c0 .336-.191.48-.526.48H6.459c-.335 0-.526-.144-.526-.48 0-.335.191-.526.526-.526h7.807c.335 0 .526.191.526.526Zm9.818 13.698c0 .144-.047.24-.144.335a.542.542 0 0 1-.382.144.434.434 0 0 1-.336-.144l-7.183-7.136c-1.772 1.58-3.831 2.395-6.226 2.395-2.586 0-4.789-.91-6.61-2.73C1.91 15.176 1 12.973 1 10.386c0-2.585.91-4.788 2.73-6.656C5.55 1.91 7.752 1 10.34 1c2.586 0 4.788.91 6.608 2.73 1.82 1.868 2.73 4.07 2.73 6.657 0 2.394-.814 4.501-2.394 6.274l7.183 7.136c.096.191.144.287.144.335Zm-5.89-13.698c0-2.346-.815-4.31-2.443-5.939-1.628-1.629-3.592-2.442-5.89-2.442-2.347 0-4.31.814-5.94 2.442-1.628 1.628-2.442 3.593-2.442 5.94 0 2.299.815 4.262 2.443 5.89 1.628 1.628 3.592 2.442 5.939 2.442 2.299-.047 4.262-.862 5.89-2.49 1.628-1.58 2.443-3.544 2.443-5.843Z' />
);

export const viewBox = '0 0 25 25';
